import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { resultMemoize } from '@ngrx/store';
import { Observable, of, switchMap } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { SsdpGradeRequestDataView } from '../../ssdp/model/ssdp-grade-request-data-view';
import { SearchStudentRequestDataView, SsdpRequestDataView } from '../../ssdp/model/ssdp-request-data-view';
import { dtmonResponse, DtMonGradeAgeResponseDataView } from '../../../model/reports/exportsModels';
import { SsdpSubgranteeMPORequestDataView, SsdpSubgranteeStatePerformanceRequestDataView } from '../../ssdp/model/ssdp-subgrantee-request-data-view';
import { SsdpMpoResponseDataView, SsdpStatePerformanceResponseDataView } from '../../ssdp/model/ssdp-subgrantee-response-data-view';
import { DtMonGradeAgeRequestDataView } from '../model/dtmonGradeAge-request-data-view';

@Injectable({
    providedIn: 'root'
})
export class DtMonService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    GetDtMonGradeAgeReport(dtmongGradeAgeRequestDataView: DtMonGradeAgeRequestDataView): Observable<DtMonGradeAgeResponseDataView> {
        return this.post<any>(EndPoints.dtMonGradeAge, false, '', dtmongGradeAgeRequestDataView).pipe(
            switchMap((result: dtmonResponse) => {
                return of(result.dtmonResponseDataView);
            })
        );
    }

}
